import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { reviews } from '../data/content';
import Reveal from './Reveal';
import SectionLabel from './SectionLabel';

const { FiStar } = FiIcons;

function ReviewCard({ review }) {
  return (
    <article className="review-card">
      <div className="stars" aria-label="Five out of five stars">
        {[0, 1, 2, 3, 4].map((star) => (
          <SafeIcon key={star} icon={FiStar} />
        ))}
      </div>
      <blockquote>“{review.quote}”</blockquote>
      <footer>
        <strong>{review.name}</strong>
        <span>{review.role}</span>
      </footer>
    </article>
  );
}

function Reviews() {
  return (
    <section className="indexed-section reviews-section" id="reviews">
      <SectionLabel number="03" label="REVIEWS" />
      <div className="section-content">
        <Reveal className="section-heading">
          <p className="eyebrow">Word from the work</p>
          <h2>What clients say after we work together</h2>
        </Reveal>
        <div className="review-grid">
          {reviews.map((review, index) => (
            <Reveal key={review.name} delay={(index % 2) * 0.08}>
              <ReviewCard review={review} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Reviews;